module.exports = __webpack_public_path__ + "img/ONG.f29f22ae.png";